import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, TextField, LegacyCard, Page } from '@shopify/polaris'
import AuthAction from 'Redux/AuthRedux'
import { useHistory } from 'react-router-dom'
import { setString } from 'Themes/constants'
import SettingsActions from 'Redux/SettingsRedux'

function Login(props) {
  const history = useHistory()
  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [showCode, setShowCode] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  useEffect(() => {}, [])

  const onAction = async () => {
    setLoading(true)
    let shopify_domain = props.shopify_domain
    if (showCode) {
      dispatch(
        AuthAction.verifyCodeRequest(
          { email: email.toLowerCase(), shopify_domain, otp: code },
          (resp, err) => {
            if (!!err) {
              setLoading(false)
              setError(err, replace('{{store_owner}}', props.store_email))
            } else {
              setString('token', resp.data.token)
              dispatch(
                AuthAction.me(resp.data.token, (resp) => {
                  dispatch(SettingsActions.setSettings(resp.data))
                  setLoading(false)
                  props.setToggle(false)
                  history.push('/apps/customer_portal/upcoming_bookings')
                })
              )
            }
          }
        )
      )
    } else {
      dispatch(
        AuthAction.sendEmailRequest(
          { email: email.toLowerCase(), shopify_domain },
          (resp, err) => {
            setLoading(false)
            if (!!err) {
              setError(err)
            } else {
              setShowCode(true)
            }
          }
        )
      )
    }
  }

  return (
    <div className="page-container">
      <div className="gradient-background">
        <div className="card-div">
          <h1 className="ui-heading">Log in</h1>
          <h3 className="ui-subheading ui-subheading--subdued">
            Continue to Your Booking Portal
          </h3>
          <TextField
            label="Email"
            onChange={(value) => setEmail(value)}
            value={email}
            helpText={
              'Please use the email with which you purchased the order or made the booking'
            }
            error={!showCode && error}
          />

          {showCode && (
            <div style={{ marginTop: 20 }}>
              <TextField
                label="Code"
                onChange={(value) => setCode(value)}
                value={code}
                error={error}
                helpText="An email has been sent with the code. Please add it here"
              />
            </div>
          )}

          <div style={{ marginTop: 20 }}>
            <Button
              onClick={onAction}
              disabled={showCode ? !code : !email}
              loading={loading}
              variant="primary"
            >
              {showCode ? 'Verify Code' : 'Send Verification Code'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
